import { f as o } from "../../fuzzysort-eoXOpoo6.js";
import { highlightQueryInLabelValue as s } from "./highlightQueryInLabelValue.js";
const m = (e, r, t) => o.go(e, r, {
  key: "label",
  limit: t,
  threshold: -5e3
}).map((l) => s(l.obj, e));
export {
  m as searchLabelValues
};
